export const excludeListQueryKeys = {
  all: (workspaceId: string) => [workspaceId, 'exclude-list'] as const,
};
